import { channel } from "@/lib/Types/Channel";
import { Environment } from "@/lib/StaticData/environmentConfig";
import { WhitelabelConfig, WhitelabelNames } from "@/whitelabel/helpers/types";

// Booking window (Buchungsdatum), inclusive: 01.06.2026 – 31.07.2026.
// YYYY-MM-DD parsed as UTC midnight (matches isDateRangeLimitedBannerVisible).
const WEG_PERKS_START = new Date("2026-06-01");
const WEG_PERKS_END = new Date("2026-08-01"); // exclusive → 31.07 inclusive

export const isWithinWegPerksWindow = (now: Date = new Date()): boolean =>
  now >= WEG_PERKS_START && now < WEG_PERKS_END;

export const shouldShowWegPerks = (
  WlConfig: WhitelabelConfig,
  currentChannel: channel,
  currentEnv?: Environment,
): boolean => {
  // Outside production (local/QA/stage) ignore the booking-window START so the
  // Product Owner can preview the perks before the promo opens, but still
  // respect the END so perks disappear after 31.07.2026 everywhere — matches
  // isDateRangeLimitedBannerVisible. Missing env is treated as production.
  const isNonProd = currentEnv != null && currentEnv !== "production";
  const now = new Date();
  const isWithinWindow = isNonProd
    ? now < WEG_PERKS_END
    : isWithinWegPerksWindow(now);

  return (
    WlConfig.name === WhitelabelNames.wegde &&
    currentChannel === channel.PACKAGE &&
    isWithinWindow
  );
};

export const WEG_PERKS_TERMS_LINK =
  "https://www.weg.de/info/nutzungsbedingungen-extras";

export type WegPerkKey = "esim" | "fotos";

export const WEG_PERKS: ReadonlyArray<{
  key: WegPerkKey;
  label: string;
  info: string;
}> = [
  {
    key: "esim",
    label: "3 GB mobile Daten inklusive",
    info: "Buche jetzt deinen Urlaub und erhalte eine kostenlose eSim mit 3 GB mobile Daten.",
  },
  {
    key: "fotos",
    label: "10 Urlaubsfotos gratis",
    info: "Buche jetzt deinen Urlaub und erhalte nach deiner Rückkehr einen Gutschein für 10 Urlaubsfotos gratis.",
  },
];
